import { useContext, useEffect, useState } from 'react';
import { LangContext } from '../../../providers/LangContext';
import SafeHtmlRenderer from '../../../providers/SafeHtmlRender';
import { PageService } from '../../../services/pageService';
import './page.scss';
import { LoaderSpinner } from '../loaderSpinner/loaderSpinner';
import { useLocation, useParams } from 'react-router-dom';


  export function Page() {
    
    useContext(LangContext);
    const params = useParams();
    const location = useLocation();
    const urlParsed = location.pathname.split('/');
    const slug = `${urlParsed.at(-1)}-${params.lang}`
    const [pageContent,setPageContent] = useState<any>(null);
    const [pageTitle,setPageTitle] = useState<string>('');
    const pageService = PageService();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLang = async () => {
            try{
                setLoading(true);
                const res = await pageService.getPage(slug);
                setPageTitle(res.data[0]?.title?.rendered);
                setPageContent(res.data[0]?.content?.rendered);
            }catch(error){
                console.error("Erreur récupération page", error);
            }finally{
                setLoading(false);
            }
        }
        fetchLang();
    }, [location.pathname]);

    return(
        <>
            {loading ? (
                <LoaderSpinner visible={true} />
            ) : (
            <div className='page-container'>
                <h1>{pageTitle}</h1>
                <div className='wp-content'>
                    {pageContent && <SafeHtmlRenderer html={pageContent} />}
                </div>
            </div>
            )}
        </>
    )
}